import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {TelemetryOPEEnum} from "./TelemetryOPEEnum";
import {BucketUnitEnum} from "../../enums/dashboard/ChartsEnum";

class O {
  bc!: AIKBinaryContentDTO
}

export class AIKBinaryContentDTO {
  mimeType!: string;
  ba!: string;
  fileName!: string;
}

/**
 * O Inner Class
 */
class I {

  groupId!: number;
  dateFrom!: number;
  dateTo!: number;
  bucketUnits!: BucketUnitEnum;
  bucketValue!: number;

  constructor() {
  }

}


export class DownloadTimeChartMetricsCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(TelemetryOPEEnum.DownloadTimeChartMetrics);
    this.i = new I();
    this.o = new O();
  }
}
